export const protectedPaths = ["/", "/load-rates", "/market-potential", "/profile", "/company-analytics", "/trends", "/loadboard"];
